<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-p-6">
    <div class="ts-space-y-4">
      <label
        class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
        style="height: 45px;">
        <i class="fa fa-forward fa-fw fa-lg ts-pb-1" style="color: white;"></i>
        <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.queueList') }}</h4>
      </label>
      <div class="ts-border-t ts-border-gray-300 ts-pt-4">
        <a-tabs :defaultActiveKey="defaultActiveKey">
          <a-tab-pane v-for="(productList, index) in queueProducts" :key="index" :tab="index">
            <div>
              <a-tabs type="card" v-model:activeKey="activeKey" size="small">
                <a-tab-pane :key="1">
                  <template #tab>
                    <span>
                      <i class="fas fa-history"></i>
                      {{ $t('restaurantSale.pending') }}
                    </span>
                  </template>
                  <div class="pos pos-counter">
                    <div class="pos-counter-body">
                      <div class="pos-counter-content">
                        <vue-custom-scrollbar class="pos-counter-content-container">
                          <ts-loading-banner :loading="false">
                            <div class="table-row">
                              <QueueCard v-for="(product, index) in getProductByStatus(productList, 1)" :key="index"
                                :product="product" :selected="false" @cancel="$emit('cancel')"
                                @fetchTableByInterval="$emit('fetchTableByInterval', $event)" />
                            </div>
                          </ts-loading-banner>
                        </vue-custom-scrollbar>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane :key="2">
                  <template #tab>
                    <span>
                      <i class="fas fa-hourglass-end"></i>
                      {{ $t('restaurantSale.completed') }}
                    </span>
                  </template>
                  <div class="pos pos-counter">
                    <div class="pos-counter-body">
                      <div class="pos-counter-content">
                        <vue-custom-scrollbar class="pos-counter-content-container">
                          <ts-loading-banner :loading="false">
                            <div class="table-row">
                              <QueueCard v-for="(product, index) in getProductByStatus(productList, 2)" :key="index"
                                :product="product" :selected="false" @cancel="$emit('cancel')"
                                @fetchTableByInterval="$emit('fetchTableByInterval', $event)" />
                            </div>
                          </ts-loading-banner>
                        </vue-custom-scrollbar>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
      <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
        {{ $t('restaurantSale.back') }}</ts-button>
    </div>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import QueueCard from './queue-card.vue'

export default {
  props: ['tableSelected', 'ref_customer_member_card_id'],
  name: 'queueList',
  components: {
    RecieptPreview,
    QueueCard
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      waiting: false,
      isScanning: false,
      activeKey: 1,
    }
  },
  created() { },
  computed: {
    defaultActiveKey() {
      return Object.keys(this.queueProducts)[0]
    },
    queueProducts() {
      return this.$store.state.restaurantSale.counterCheckout.tables
        .filter(item => item.invoice_detail && item.invoice_detail.length > 0)
        .flatMap(item => item.invoice_detail.map(detail => ({
          ...detail,
          table: item
        })))
        .filter(item => item.service_length != null && (item.table.linked_keys.length > 0 ? item.ref_table_id == null : true == true))
        .reduce((groups, detail) => {
          const key = detail.product_name_en || 'Unknown Product'
          if (!groups[key]) {
            groups[key] = []
          }
          groups[key].push(detail)
          return groups
        }, {})
    },
  },
  methods: {
    getProductByStatus(productList, status) {
      if (status == 1) {
        return productList.filter(el => el.end_time == null)
      }
      if (status == 2) {
        return productList.filter(el => el.end_time != null)
      }
      return productList
    },
  }
}
</script>
<style scoped lang="scss">
.pos-counter {
  padding-top: 0;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }

}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>